var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 3.18312C6.23475 3.18312 3.18214 6.23572 3.18214 10.0013C3.18214 13.7669 6.23475 16.8195 10.0003 16.8195C13.7659 16.8195 16.8185 13.7669 16.8185 10.0013C16.8185 6.23572 13.7659 3.18312 10.0003 3.18312ZM1.66699 10.0013C1.66699 5.39893 5.39795 1.66797 10.0003 1.66797C14.6027 1.66797 18.3337 5.39893 18.3337 10.0013C18.3337 14.6037 14.6027 18.3346 10.0003 18.3346C5.39795 18.3346 1.66699 14.6037 1.66699 10.0013Z",
    fill: "#E9372A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48517 6.971C8.90357 6.971 9.24275 7.31018 9.24275 7.72857V12.274C9.24275 12.6924 8.90357 13.0316 8.48517 13.0316C8.06678 13.0316 7.7276 12.6924 7.7276 12.274V7.72857C7.7276 7.31018 8.06678 6.971 8.48517 6.971Z",
    fill: "#E9372A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5155 6.971C11.9339 6.971 12.2731 7.31018 12.2731 7.72857V12.274C12.2731 12.6924 11.9339 13.0316 11.5155 13.0316C11.0971 13.0316 10.7579 12.6924 10.7579 12.274V7.72857C10.7579 7.31018 11.0971 6.971 11.5155 6.971Z",
    fill: "#E9372A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.16df52cbce209455afb7b497d748806b.svg";
export { ForwardRef as ReactComponent };